import React, { Component } from "react";
import "./style.css";
import "../../../../../index.css";
class TrinityConditionConfirm extends Component {
  render() {
    const {
      visible,
      close,
      statInfo,
      subjectCondition,
      wholeSubject,
      time,
      handleConfirm,
    } = this.props;
    return (
      <div
        className={
          visible === true
            ? "trinity_condition_confirm_box"
            : "trinity_condition_confirm_box display_none"
        }
      >
        <div className="trinity_condition_confirm_inline_box">
          <div
            onClick={() => close()}
            className="trinity_condition_confirm_close"
          >
            <img
              alt=""
              src={require("../../../../../images/user/close.png")}
            ></img>
          </div>
          <div className="trinity_condition_confirm_subject">
            <span className="fl">选考科目：</span>
            <span className="fl">{wholeSubject[subjectCondition[0]]}</span>
            <span className="fl major_left_5">
              {wholeSubject[subjectCondition[1]]}
            </span>
            <span className="fl major_left_5">
              {wholeSubject[subjectCondition[2]]}
            </span>
          </div>
          <div className="trinity_condition_confirm_level">
            <span className="fl">学考总计：</span>
            <span className="fl">
              <span className={statInfo["A"] === 0 ? "display_none" : ""}>
                {statInfo["A"]}A{" "}
              </span>
            </span>
            <span className="fl major_left_5">
              <span className={statInfo["B"] === 0 ? "display_none" : ""}>
                {statInfo["B"]}B{" "}
              </span>
            </span>
            <span className="fl major_left_5">
              <span className={statInfo["C"] === 0 ? "display_none" : ""}>
                {statInfo["C"]}C{" "}
              </span>
            </span>
            <span className="fl major_left_5">
              <span className={statInfo["D"] === 0 ? "display_none" : ""}>
                {statInfo["D"]}D{" "}
              </span>
            </span>
            <span className="fl major_left_5">
              <span className={statInfo["E"] === 0 ? "display_none" : ""}>
                {statInfo["E"]}E{" "}
              </span>
            </span>
          </div>
          <div className="clear"></div>
          <div className="trinity_condition_confirm_info">
            *&nbsp;&nbsp;修改次数有限，借用将不能改回。
          </div>
          <div
            onClick={() => handleConfirm()}
            className={
              time > 0
                ? "trinity_condition_confirm_disabled_btn"
                : "trinity_condition_confirm_btn"
            }
          >
            {time > 0 ? time : "确 认"}
          </div>
        </div>
      </div>
    );
  }
}
export default TrinityConditionConfirm;



// WEBPACK FOOTER //
// ./src/containers/Trinity/TrinityCondition/components/TrinityConditionConfirm/index.js